/* eslint-disable import/no-cycle */
// Utils
import { isObject } from 'ezyvet-fe-helpers';
import { commitArray } from './commitArray';
import { commitObject } from './commitObject';
/**
 * Commit a value, detecting what type and acting accordingly.
 * If not an array or object this just returns the value.
 *
 * @param {any} value
 *
 * @return {any}
 */
export var commitOrReturn = function (value) {
    if (Array.isArray(value)) {
        return commitArray(value);
    }
    if (isObject(value)) {
        // we commit and return
        return commitObject(value);
    }
    return value;
};
//# sourceMappingURL=commitOrReturn.js.map